import { CheckBox } from '@mui/icons-material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {Container, Paper, Grid, Box, Button, FormControl,InputLabel, Select, MenuItem, Typography, Backdrop, CircularProgress, TableContainer, Table, TablePagination, TableBody, TableHead, TableCell, TableRow, TextField} from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate , useLocation, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import SearchBox from '../../components/SearchBox';
import fetchTableData from '../../components/fetchTableData';
import { auth } from '../../config/firebase';

const Orders = () => {
    const user = auth.currentUser;
    
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState('');
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;
    const [searchUserEmail, setSearchUserEmail] = useState('');
    const [searchStatus, setSearchStatus] = useState('all');
    const [createdTimeFrom, setCreatedTimeFrom] = useState('');
    const [createdTimeTo, setCreatedTimeTo] = useState('');
    const [paginatedList, setPaginatedlist] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [dateError, setDateError] = useState('');

    const handleChangePage = async (event, newPage) => {
        setPage(newPage);
        const queryParams = new URLSearchParams();
        if(searchUserEmail) queryParams.set('userEmail', searchUserEmail);
        if(searchStatus) queryParams.set('status', searchStatus);
        if(createdTimeTo) queryParams.set('createdTimeTo', createdTimeTo);
        if(createdTimeFrom) queryParams.set('createdTimeFrom', createdTimeFrom);
        queryParams.set('page', newPage + 1);
        navigate(`/dashboard/orders?${queryParams.toString()}`);
    };

    const handleChangeRowsPerPage = () => {
        //
    }

    const handleInputChange = (e) => {
        setSearchUserEmail(e.target.value);
    }
    
    const handleSearch = (navUrl) => {
        const queryParams = new URLSearchParams();
        if(searchUserEmail) queryParams.set('userEmail', searchUserEmail);
        if(searchStatus && searchStatus !== 'all') queryParams.set('status', searchStatus);
        if(createdTimeTo) queryParams.set('createdTimeTo', createdTimeTo);
        if(createdTimeFrom) queryParams.set('createdTimeFrom', createdTimeFrom);
        queryParams.set('page',1);
        setPage(0);
        const fullUrl = `${navUrl}?${queryParams.toString()}`;
        navigate(fullUrl);
    }
    const handleReset = (navUrl) => {
        setSearchUserEmail('');
        setSearchStatus('all');
        setCreatedTimeFrom('');
        setCreatedTimeTo('');
        setPage(0);
        setDateError('');
        navigate(navUrl);
    }
    
    useEffect(() => {
        const dataKey = 'orders';
        const creationTimeFromUrl = searchParams.get("createdTimeFrom") || '';
        const creationTimeToUrl = searchParams.get("createdTimeTo") || '';
        const searchUserEmailUrl = searchParams.get("userEmail") || '';
        const statusFilterUrl = searchParams.get("status") || 'all';
        const pageUrl = parseInt(searchParams.get("page") || '1', 10) - 1;

        setSearchUserEmail(searchUserEmailUrl);
        setSearchStatus(statusFilterUrl);
        setCreatedTimeFrom(creationTimeFromUrl);
        setCreatedTimeTo(creationTimeToUrl);
        setPage(pageUrl);
        let apiUrl = `${process.env.REACT_APP_API_BASE_URL}xeo/v1/orders`;

        const params = new URLSearchParams();
        if (creationTimeFromUrl) params.append("created_from", creationTimeFromUrl);
        if (creationTimeToUrl) params.append("created_to", creationTimeToUrl);
        if (searchUserEmailUrl) params.append("user_email", searchUserEmailUrl);
        if (statusFilterUrl && statusFilterUrl != 'all') params.append("status", statusFilterUrl);
        //if (pageUrl) params.append("page", pageUrl);
        let useOffset = false;
        if(pageUrl){
            const offsetParam = pageUrl * 10;
            params.append("offset",offsetParam);
            params.append("limit",10);
            useOffset = true;
        }
        if ([...params].length > 0) {
            apiUrl += `?${params.toString()}`;
        }
        fetchTableData({user, searchParams, setLoading, apiUrl, dataKey, rowsPerPage: 10, setPaginatedlist, setTotalCount, setPage, useOffset });
    },[location.search, navigate]);
    

    return(
    <Container maxWidth={false} sx={{ width: '100%', padding: 0, paddingBottom: '5px' }}>
        <Box alignItems="center" sx={{ paddingTop: '10px' }}>
            <Box  xs={4.5}>
                <Typography variant='h5' gutterBottom paddingLeft={"6px"}>
                    Orders
                </Typography>
            </Box>
        </Box>
        <SearchBox
            searchLable="Search Order By User Email"
            searchTerm={searchUserEmail}
            handleInputChange={handleInputChange}
            handleSearch={() => handleSearch(`/dashboard/orders`)}
            handleReset={() => handleReset(`/dashboard/orders`)}
        >
            <FormControl  fullWidth variant="standard">
                <InputLabel>Status</InputLabel>
                <Select
                    value={searchStatus}
                    onChange={(e) => setSearchStatus(e.target.value)}
                    lable="Status"
                >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="completed">Completed</MenuItem>
                    <MenuItem value="scheduled">Scheduled</MenuItem>
                    <MenuItem value="refunded">Refunded</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="failed">Failed</MenuItem>
                    <MenuItem value="fraud">Fraud</MenuItem>
                    <MenuItem value="cancelled">Cancelled</MenuItem>
                </Select>
            </FormControl>
            <TextField
                fullWidth
                label="From (Creation Time)"
                variant="standard"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={createdTimeFrom || ''}
                helperText={
                    dateError ? (
                        <span style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>
                            <ErrorOutlineIcon sx={{ fontSize: '16px', marginRight: '2px' }} />
                            {dateError}
                        </span>
                    ) : null
                }
                onChange={(e) => {
                    const fromDate = new Date(e.target.value);
                    const toDate = new Date(createdTimeTo);
                    if (toDate < fromDate) {
                        setDateError('To date > From date');
                    } else {
                        setDateError('');
                    }
                    setCreatedTimeFrom(e.target.value);
                }}
                error={Boolean(dateError)}
                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />
            <TextField
                fullWidth
                label="To (Creation Time)"
                variant="standard"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={createdTimeTo || ''}
                helperText={
                    dateError ? (
                        <span style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>
                            <ErrorOutlineIcon sx={{ fontSize: '16px', marginRight: '2px' }} />
                            {dateError}
                        </span>
                    ) : null
                }
                onChange={(e) => {
                    const toDate = new Date(e.target.value);
                    const fromDate = new Date(createdTimeFrom);
                    if (toDate < fromDate) {
                        setDateError('To date > From date');
                    } else {
                        setDateError('');
                    }
                    setCreatedTimeTo(e.target.value);
                }}
                error={Boolean(dateError)}
                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />
        </SearchBox>
        {loading ? (
            <Backdrop open={true} style={{ color: '#fff', zIndex: 1 }}>
                <CircularProgress  color="inherit" />
            </Backdrop>
        ) : (
            <TableContainer component={Paper} style={{ marginTop: 20 }}>
                <Table>
                    <TableHead>
                        <TableRow  style={{ fontWeight: 'bold' }}>
                            <TableCell style={{ fontWeight: 'bold' }}>Order Id</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>User Id</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>User Email</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Plan Id</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Plan Name</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Plan Type</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Plan Price</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Credit Amount</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Paid Price</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Payment Processor</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Creation Time</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                            {paginatedList?.map(order => {
                                return (
                                    <TableRow key={order.ID}>
                                        <TableCell>
                                            {order.ID}
                                        </TableCell>
                                        <TableCell>
                                            {order.UserID}
                                        </TableCell>
                                        <TableCell>
                                            {order.User.Email}
                                        </TableCell>
                                        <TableCell>
                                            {order.PlanID}
                                        </TableCell>
                                        <TableCell>
                                            {order.plan_info?.name || '-'}
                                        </TableCell>
                                        <TableCell>
                                            {order.plan_info?.type || '-'}
                                        </TableCell>
                                        <TableCell>
                                            {order.original_amount}
                                        </TableCell>
                                        <TableCell>
                                            {order.plan_info?.credits || '0'}
                                        </TableCell>
                                        <TableCell>
                                            {order.Amount}
                                        </TableCell>
                                        <TableCell>
                                            {order.Status}
                                        </TableCell>
                                        <TableCell>
                                            {order.PaymentProcessor}
                                        </TableCell>
                                        <TableCell>
                                            {moment(order.creationTime).format('YYYY-MM-DD HH:mm')}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
        )}
        <div style={{ flexGrow: 1 }} />
        <TablePagination
            component="div"
            count={totalCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[]}
            style={{ paddingBottom: '20px', paddingTop: '10px', overflow: 'hidden' }}
        />
    </Container>);
}

export default Orders;